import { createRouter, createWebHistory } from "vue-router";
import DetailView from "../views/DetailView.vue";
import HomeView from "../views/HomeView.vue";
import { event } from "vue-gtag";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    props: true,
  },
  {
    path: "/:slug",
    name: "detail",
    component: DetailView,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  event("submission-view", { submission: to.params.slug });
  next();
});

export default router;
